import type { ReactNode } from 'react';

interface SectionHeadingProps {
  index: string;
  kicker: string;
  title: ReactNode;
  sub?: ReactNode;
  light?: boolean;
}

export default function SectionHeading({ index, kicker, title, sub, light }: SectionHeadingProps) {
  return (
    <div className="max-w-3xl">
      <div className="flex items-center gap-2.5">
        <span className="flex h-6 w-8 items-center justify-center rounded-sm bg-primary-500 font-heading text-[13px] font-bold text-background-50">
          {index}
        </span>
        <span
          className={
            'flex items-center gap-2 text-[13px] font-semibold tracking-[0.16em] uppercase ' +
            (light ? 'text-primary-300' : 'text-primary-700')
          }
        >
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500"></span>
          {kicker}
        </span>
      </div>
      <h2
        className={
          'mt-4 font-heading text-2xl font-black leading-tight tracking-tight md:text-4xl ' +
          (light ? 'text-foreground-50' : 'text-foreground-950')
        }
      >
        {title}
      </h2>
      {sub && (
        <p className={'mt-4 text-[15px] leading-relaxed md:text-base ' + (light ? 'text-foreground-300' : 'text-foreground-600')}>
          {sub}
        </p>
      )}
    </div>
  );
}